import { render } from "./AddGpsReportForMatch.vue?vue&type=template&id=3920561c&scoped=true"
import script from "./AddGpsReportForMatch.vue?vue&type=script&lang=js"
export * from "./AddGpsReportForMatch.vue?vue&type=script&lang=js"

import "./AddGpsReportForMatch.vue?vue&type=style&index=0&id=3920561c&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3920561c"]])

export default __exports__